import { useMemo, useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';

import ptBR from '../locales/pt-BR.json';
import en from '../locales/en.json';
import es from '../locales/es.json';
import fr from '../locales/fr.json';
import it from '../locales/it.json';
import sv from '../locales/sv.json';
import no from '../locales/no.json';
import da from '../locales/da.json';

const TRANSLATIONS = {
  'pt-BR': ptBR,
  'en': en,
  'es': es,
  'fr': fr,
  'it': it,
  'sv': sv,
  'no': no,
  'da': da
};

/**
 * Hook para traduções com suporte a múltiplos idiomas
 */
export const useTranslation = () => {
  const { currentLanguage, changeLanguage } = useContext(LanguageContext);

  const translations = useMemo(() => {
    return TRANSLATIONS[currentLanguage] || TRANSLATIONS['pt-BR'];
  }, [currentLanguage]);

  /**
   * Função para obter tradução por caminho
   * @param {string} path - Caminho do texto (ex: "common.back", "layers.title")
   * @param {object} params - Parâmetros para interpolação (opcional)
   * @returns {string} - Texto traduzido
   */
  const t = (path, params = {}) => {
    const keys = path.split('.');
    let value = translations;
    
    for (const key of keys) {
      if (value && typeof value === 'object') {
        value = value[key];
      } else {
        console.warn(`Translation not found for path: ${path}`);
        return path;
      }
    }
    
    // Interpolação de parâmetros (ex: "Hello {name}" com params = {name: "World"})
    if (typeof value === 'string' && params) {
      return value.replace(/\{(\w+)\}/g, (match, key) => {
        return params[key] !== undefined ? params[key] : match;
      });
    }
    
    return value || path;
  };

  return { t, currentLanguage, changeLanguage };
};

export default useTranslation;

